import React from "react";
import UseCaseHeader from "components/UseCaseHeader";
import ServiceLogoGrid from "components/ServiceLogoGrid";
import { USE_CASES } from "utils/constants/useCases";
import IMAGES from "utils/constants/image";
import { SMS_SERVICES } from "utils/constants/useCases";
import { styles } from "./styles";

const COPY_PRIMARY =
  "With open rates as high as 98% and response rates of 20%, SMS is an incredible channel for customer engagement.";
const COPY_SECONDARY =
  "Payment links allow your team to sell directly over SMS to help drive more revenue from this high engagement.";

const SMS = () => {
  const compatibleWith = (
    <div className="w-100 pt3">
      <div className="f6 black-50 pb2 pb0-l">Compatible with</div>
      <ServiceLogoGrid services={Object.values(SMS_SERVICES)} />
    </div>
  );
  return (
    <section className="w-100">
      <div className="w-100 w-50-ns fr relative">
        <UseCaseHeader type={USE_CASES.SMS} />
        <div className="f5 f4-l tl lh-copy pt2 pt4-l">
          {COPY_PRIMARY}
          <sup className="f7">[5]</sup>
        </div>
        <div className="dn dib-ns">
          <div className="f5 f4-l mb3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <div className="w-100 w-50-ns fr pt3 pt0-l">
        <div className={`${IMAGES.USE_CASE_SMS}--wrapper`}>
          <div className={`${IMAGES.USE_CASE_SMS}--img contain contain`} />
        </div>
        <div className="w-100 dn-ns dib">
          <div className="f5 f4-l fw4 mb3 mt3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <style jsx>{styles}</style>
    </section>
  );
};

export default SMS;
